import { c as _c } from "react/compiler-runtime";
import { Dispatch, MouseEvent, ReactElement, SetStateAction } from 'react';
import { IconButton, InputAdornment, VisibilityIcon, VisibilityOffIcon } from '@internations/ds';
type PasswordVisibilityAdornmentProps = {
  showPassword: boolean;
  setShowPassword: Dispatch<SetStateAction<boolean>>;
};
export const PasswordVisibilityAdornment = t0 => {
  const $ = _c(6);
  const {
    showPassword,
    setShowPassword
  } = t0;
  const mouseHandler = _temp;
  const t1 = showPassword ? "hide the password" : "display the password";
  let t2;
  if ($[0] !== setShowPassword) {
    t2 = () => setShowPassword(_temp2);
    $[0] = setShowPassword;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = showPassword ? VisibilityOffIcon : VisibilityIcon;
  let t4;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = <InputAdornment position="end"><IconButton aria-label={t1} onClick={t2} onMouseDown={mouseHandler} onMouseUp={mouseHandler} edge="end" Icon={t3} /></InputAdornment>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
function _temp(event) {
  return event.preventDefault();
}
function _temp2(show) {
  return !show;
}